import { ISelectItem } from '@lla-platform/core/core-ui'

export const AllTimezones: ISelectItem[] = [
  'Alaskan Standard Time',
  'Atlantic Standard Time',
  'Central Standard Time',
  'Eastern Standard Time',
  'Hawaiian Standard Time',
  'Mountain Standard Time',
  'Newfoundland Standard Time',
  'Pacific Standard Time',
  'US Mountain Standard Time'
].map((timeZone) => ({
  value: timeZone,
  label: timeZone
}))
